import Vue from 'vue/dist/vue.esm.js';
import gsap from 'gsap';

// DUMMY DATA
let data = [
  {
    image: 'https://via.placeholder.com/300x250?text=article%20image',
    title: 'Ten myths of  breast reduction',
    author: 'Dr. Julian Liew',
    date: 'Nov 2020',
    url: 'https://www.google.com/',
  },
  {
    image: 'https://via.placeholder.com/300x250?text=article%20image',
    title: 'Ten myths of  breast reduction',
    author: 'Dr. Julian Liew',
    date: 'Nov 2020',
    url: 'https://www.google.com/',
  },
  {
    image: 'https://via.placeholder.com/300x250?text=article%20image',
    title: 'Ten myths of  breast reduction',
    author: 'Dr. Julian Liew',
    date: 'Nov 2020',
    url: 'https://www.google.com/',
  },
]

Vue.component('related-reading', {
  data() {
    return {
      elements: data,
      activeIndex: 0,
    }
  },
  props: {
    elements: {
      type: Array,
      required: true,
      default: ()=>{
        return data;
      }
    }
  },
  mounted(){
    this.setupIntersection();
  },
  methods: {
    setActiveIndex: function(index){
      this.activeIndex = index;
    },
    scrollToAndUpdateIndex: function(index){
      document.querySelector('.related-reading__content').scrollLeft =
        document.querySelector(`.related-reading__content [data-index="${index}"]`).offsetLeft - 37;
      this.setActiveIndex(index);
    },
    setupIntersection: function(){
      const allEls = document.querySelectorAll(".related-reading__el");
      const options = {
        root: document.querySelector('.related-reading__content'),
        rootMargin: '0px',
        threshold: 0.9
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.setActiveIndex(entry.target.dataset.index);
          }
        });
      }, options);

      allEls.forEach((el)=>{
        observer.observe(el);
      })
    }
  }
});

new Vue({}).$mount('#relatedWrapper');
